<template>

  <div class="sidebar vh-100 overflow-auto border" style="background-color: #F5F6FA;">
    <!-- Header -->
    <div class="text-center align-items-center  mb-4 pt-3">
        <img src="../assets/envionyx-logo.png" alt="" style="height: 30px;">
                 <img class="ms-1" src="../assets/envionyx-banner.png" alt="" style="height: 18px;">
    </div>
<div class="">
        <router-link
         to="/"  style="text-decoration: none;"> 
          <button
            :class="[
              'menu-item w-100 d-flex align-items-center gap-3 p-x3 py-0 rounded border']">
            <div :class="[
              'icon-box rounded d-flex align-items-center justify-content-center']">
        <i class="bi bi-arrow-left"></i>
            </div>
            <span class="menu-label" style="font-family: 'Kanit-regular';">
             กลับไปยังหน้าหลัก
            </span>
          </button>
        </router-link>
      </div>
    <!-- Main Menu -->
    <div class="mb-4 mt-4">
      <h2 class="account-title text-uppercase px-3 mb-3">
        User Management
      </h2>
      <router-link
        v-for="item in menuItems"
        :key="item.label"
        :to="item.path"
        custom
        v-slot="{ navigate, isActive }"
      >
        <!-- Hide Group menu if not Owner -->
        <button
          v-if="item.label !== 'จัดการกลุ่ม' || isOwner"
          @click="navigate"
          :class="[
            'menu-item w-100 d-flex align-items-center gap-3 px-3 py-2 rounded border-0 mb-2',
            isActive ? 'active' : ''
          ]"
        >
          <div :class="[
            'icon-box rounded d-flex align-items-center justify-content-center',
            isActive ? 'active-icon' : 'bg-secondary'
          ]">
            <i :class="[item.icon, 'text-white']"></i>
          </div>
          <span class="menu-label">
            {{ item.label }}
          </span>
        </button>
      </router-link>
    </div>

    <!-- Device Management Section -->
    <div class="">
      <h2 class="account-title text-uppercase px-3 mb-3">
        Hardware Management
      </h2>
      <div>
        <router-link
          v-for="item in accountItems"
          :key="item.label"
          :to="item.path"
          custom
          v-slot="{ navigate, isActive }"
        >
          <button
            @click="navigate"
            :class="[
              'menu-item w-100 d-flex align-items-center gap-3 px-3 py-2 rounded border-0 mb-2',
              isActive ? 'active' : ''
            ]"
          >
            <div :class="[
              'icon-box rounded d-flex align-items-center justify-content-center',
              isActive ? 'active-icon' : 'bg-secondary'
            ]">
              <i :class="[item.icon, 'text-white']"></i>
            </div>
            <span class="menu-label">
              {{ item.label }}
            </span>
          </button>
        </router-link>
      </div>
    </div>

   <!-- <div class="mt-5">
        <router-link
         to="/"  style="text-decoration: none;"> 
          <button
            :class="[
              'menu-item w-100 d-flex align-items-center gap-3 px-3 py-2 rounded border mb-2']">
            <div :class="[
              'icon-box rounded d-flex align-items-center justify-content-center']">
        <i class="bi bi-arrow-left"></i>
            </div>
            <span class="menu-label">
             กลับไปยังหน้าหลัก
            </span>
          </button>
        </router-link>
      </div> -->
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const role = ref('')

onMounted(() => {
  role.value = localStorage.getItem('role') || 'guest'
})

// Computed property to check if user is Owner
const isOwner = computed(() => {
  return role.value === 'Owner'
})

const menuItems = [
  { icon: 'bi-house-door', label: 'จัดการกลุ่ม', path: '/management/group/list' },
  { icon: 'bi-credit-card', label: 'รายการผู้ใช้งาน', path: '/management/user/listuser' },
  { icon: 'bi-badge-vr', label: 'ข้อมูลผู้ใช้งาน', path: '/management/info' }
]

const accountItems = [
  { icon: 'bi-wrench', label: 'รายการ Template', path: '/management/device/listtemplate' },
  { icon: 'bi-table', label: 'รายการอุปกรณ์', path: '/management/device/list' }
]
</script>

<style scoped>
.sidebar {
  width: 250px;
  padding: 1rem;
}

.logo-box {
  width: 40px;
  height: 40px;
}

.sidebar-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #344767;
}

.menu-item {
  background-color: transparent;
  text-align: left;
  transition: all 0.3s ease;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #f8f9fa !important;
}

.menu-item.active {
  background-color: white !important;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12),
              0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07);
}

.icon-box {
  width: 32px;
  height: 32px;
  min-width: 32px;
}

.active-icon {
  background-color: #7DC0F0;
}

.menu-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #67748e;
}

.menu-item.active .menu-label {
  color: #344767;
  font-weight: 600;
}

.account-title {
  font-size: 0.75rem;
  font-weight: 700;
  color: #8392ab;
  letter-spacing: 0.5px;
}
</style>